import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            漫画分类
          </h2>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}